module.exports = require("lodash.defaults");


//////////////////
// WEBPACK FOOTER
// external "lodash.defaults"
// module id = 1
// module chunks = 0